import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material'
import Footer from 'pages/home/components/Footer'

const OnboardingContainer = ({
  children,
  rightComponent,
  srcRightPhoto,
  bgColorRight,
  leftRightPhoto,
  topRightPhoto,
  heightRightPhoto = 100,
  transformRightPhoto = `translate(${0}px, ${0}px)`,
  sx,
  ...rest
}) => {
  return (
    <Box {...rest} sx={{ ...sx }}>
      <Grid container width="100%" height={sx?.height || '100vh'}>
        <Grid item xs={12} lg={6}>
          <Box width="100%" height="100%">
            {children}
          </Box>
        </Grid>
        <Grid
          item
          xs={0}
          lg={6}
          height={'100dvh'}
          display={{ xs: 'none', lg: 'flex' }}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          sx={{
            background: 'linear-gradient(87deg, #FFF7D9 23.7%, #F9F7EF 52.31%, #FFF7D9 80.93%)',
          }}
          overflow={'clip'}
        >
          <img src={'/adnexio-logo-text.svg'} width={185} height={36} alt="adnexio logo" />
          <Typography variant="h3" sx={{ color: 'text.secondary', fontWeight: 700, py: 2 }}>
            DATA-FUELED WORKFORCE
          </Typography>
          <img src={'/get_started_static.png'} alt="honeycomb" width={700} height={624} />
        </Grid>
      </Grid>
      <Footer />
    </Box>
  )
}

export default OnboardingContainer
